import { createStore } from 'vuex'

import { questions } from '@/textConfig'

export default createStore({
  state: {
    answers: [] as boolean[],
    index: 0,
    questions,
    swipeState: 'none' as 'none' | 'yes' | 'no',
  },
  getters: {
    question: (state) => state.questions[state.index],
    score: (state) => state.answers.filter((a) => a).length,
    isAllAnswered: (state) => state.answers.length === state.questions.length,
  },
  mutations: {
    answer(state, answer: boolean) {
      state.answers.push(answer)
    },
    nextQuestion(state) {
      state.index++
    },
    setSwipeState(state, newSwipeState: 'none' | 'yes' | 'no') {
      state.swipeState = newSwipeState
    },
    start() {
      return
    },
    finish() {
      return
    },
    submit() {
      return
    },
    clickYes() {
      return
    },
    clickNo() {
      return
    },
  },
  actions: {
    confirm(store) {
      const { state } = store
      if (state.index === state.questions.length - 1) {
        store.commit('finish')
      } else {
        store.commit('nextQuestion')
      }
    },
  },
  modules: {},
})
